import React, { FunctionComponent } from 'react';

import { InputStatus } from '../helpers/getFinalFieldState.types';

import { $IcoContainer } from './Depiction.styles';
import DepictionSvg from './DepictionSvg';

interface DepictionIcoProps {
  status?: InputStatus;
  name: string | undefined;
}

const DepictionIco: FunctionComponent<
  React.PropsWithChildren<DepictionIcoProps>
> = ({ status, name }) => {
  if (status) {
    return (
      <$IcoContainer
        data-testid={
          name && status
            ? `depiction-${status.toLocaleLowerCase()}-${name}`
            : undefined
        }
      >
        <DepictionSvg status={status} />
      </$IcoContainer>
    );
  }

  return null;
};

export default DepictionIco;
